(function(){
  var V={'1-ivoire':56097285210497,'1-naturel':56097285243265,'2-ivoire':56097700118913,'2-naturel':56097700151681,'3-ivoire':56097700184449,'3-naturel':56097700217217};
  var P={'1':'34,90€','2':'54,90€','3':'74,90€'};
  var W={'1':'54,90€','2':'109,80€','3':'164,70€'};
  var S={'1':'-36%','2':'-50%','3':'-55%'};
  var b='1',s='ivoire';

  function upd(){
    var ep=document.getElementById('sv-sticky-price');
    var ew=document.getElementById('sv-sticky-was');
    var eb=document.getElementById('sv-sticky-badge');
    if(ep)ep.textContent=P[b];
    if(ew)ew.textContent=W[b];
    if(eb)eb.textContent=S[b];
  }

  function addToCart(btn){
    var vid=V[b+'-'+s],orig=btn.textContent;
    btn.textContent='AJOUT EN COURS…';btn.disabled=true;
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:vid,quantity:1}]})})
    .then(function(r){return r.json()})
    .then(function(){btn.textContent='✓ AJOUTÉ !';btn.style.background='#2d7a2d';setTimeout(function(){window.location.href='/cart'},800)})
    .catch(function(){btn.textContent='ERREUR';btn.style.background='#862B28';btn.disabled=false;setTimeout(function(){btn.textContent=orig;btn.style.background=''},2000)});
  }

  function initUI(){
    document.querySelectorAll('.sv-bcard').forEach(function(c){c.addEventListener('click',function(){document.querySelectorAll('.sv-bcard').forEach(function(x){x.classList.remove('sel')});this.classList.add('sel');b=this.dataset.bundle;upd()})});
    document.querySelectorAll('.sv-shade-circle').forEach(function(c){c.addEventListener('click',function(){document.querySelectorAll('.sv-shade-circle').forEach(function(x){x.classList.remove('act')});this.classList.add('act');s=this.dataset.shade;var d=document.querySelector('.sv-shade-desc');if(d)d.innerHTML='<strong>'+s.charAt(0).toUpperCase()+s.slice(1)+'</strong> — '+(s==='ivoire'?'idéale pour les peaux claires à médium':'idéale pour les peaux médium à mates');upd()})});
    var atcBtn=document.getElementById('sv-add-to-cart');
    var stickyAtc=document.getElementById('sv-sticky-atc');
    if(atcBtn)atcBtn.addEventListener('click',function(){addToCart(this)});
    if(stickyAtc)stickyAtc.addEventListener('click',function(){addToCart(this)});

    var hrsEl=document.getElementById('sv-hrs'),minEl=document.getElementById('sv-mins'),secEl=document.getElementById('sv-secs');
    if(hrsEl&&minEl&&secEl){var h=parseInt(hrsEl.textContent)||2,m=parseInt(minEl.textContent)||47,ss=parseInt(secEl.textContent)||33;setInterval(function(){ss--;if(ss<0){ss=59;m--}if(m<0){m=59;h--}if(h<0){h=2;m=47;ss=33}hrsEl.textContent=(h<10?'0':'')+h;minEl.textContent=(m<10?'0':'')+m;secEl.textContent=(ss<10?'0':'')+ss},1000)}

    var stickyBar=document.getElementById('sv-sticky-bar');
    if(atcBtn&&stickyBar){
      var scrollRoot=document.querySelector('.page-wrapper')||window;
      scrollRoot.addEventListener('scroll',function(){var rect=atcBtn.getBoundingClientRect();if(rect.bottom<0){stickyBar.classList.add('show')}else{stickyBar.classList.remove('show')}},{passive:true});
    }

    var animEls=document.querySelectorAll('.sv-anim');
    if('IntersectionObserver' in window){
      var obsRoot=document.querySelector('.page-wrapper')||null;
      var obs=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('vis');obs.unobserve(e.target)}})},{threshold:0.15,rootMargin:'0px 0px -40px 0px',root:obsRoot});
      animEls.forEach(function(el){obs.observe(el)});
    }else{
      animEls.forEach(function(el){el.classList.add('vis')});
    }
  }

  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initUI)}else{initUI()}
})();
